<script>
    import { createEventDispatcher } from 'svelte'
    import randomId from 'random-uuid-v4'

    export let disabled
    export let helpText = ''
    export let id = randomId()
    export let label = ''
    export let maxLength
    export let placeholder = ''
    export let recommendedMaxLength
    export let required
    export let state
    export let type = 'text'
    export let value = ''

    let charactersLeft = undefined
    let computedClass = ''
    let computedMessage = ''
    let computedState = ''
    let showHelpText

    $: charactersLeft = parseInt(recommendedMaxLength || maxLength, 10) - ((value && value.length) || 0)
    $: {
        if (charactersLeft < 1 && maxLength) {
            computedClass = 'text-danger'
        } else if (charactersLeft < 1) {
            computedClass = 'text-warning'
        } else {
            computedClass = 'text-muted'
        }
    }
    $: {
        if (recommendedMaxLength && charactersLeft < 0) {
            computedMessage = `Maximum ${recommendedMaxLength} characters recommended. Characters over: ${Math.abs(
                charactersLeft
            )}`
        } else if (recommendedMaxLength) {
            computedMessage = `Maximum ${recommendedMaxLength} characters recommended. Characters remaining: ${charactersLeft}`
        } else if (maxLength) {
            computedMessage = `Maximum ${maxLength} characters. Characters remaining: ${charactersLeft}`
        } else {
            computedMessage = ''
        }
    }
    $: computedState = state ? `has-${state}` : ''

    const dispatch = createEventDispatcher()
    function update() {
        dispatch('change', value)
    }
</script>

<div class="component-form-field component-form-field-text">
    <div class="form-group {computedState}">
        {#if label || required}
            <label for={id} class="control-label">
                {label || ''}
                {#if required}<span class="glyphicon glyphicon-asterisk text-danger required-icon-alignment" />{/if}
                {#if helpText && showHelpText}<span class="text-muted"> ({helpText}) </span>{/if}
            </label>
        {/if}

        <div class={$$slots.left || $$slots.right ? 'input-group' : ''}>
            {#if $$slots.left}
                <span class="input-group-addon">
                    <slot name="left" />
                </span>
            {/if}

            {#if type === 'new-password' || type === 'current-password'}
                <input
                    type="password"
                    data-test-fanx="form-field-input-text-{(label && label.replace(' ', '-')) || ''}"
                    autocomplete={type}
                    class="form-control"
                    {id}
                    {placeholder}
                    {disabled}
                    {maxLength}
                    bind:value
                    on:input={update}
                    on:focus={() => (showHelpText = true)}
                    on:blur={() => (showHelpText = false)}
                />
            {:else if type ==='email'}
                <input
                    type="email"
                    data-test-fanx="form-field-input-text-{(label && label.replace(' ', '-')) || ''}"
                    autocomplete="email"
                    class="form-control"
                    {id}
                    {placeholder}
                    {disabled}
                    {maxLength}
                    {required}
                    bind:value
                    on:input={update}
                    on:focus={() => (showHelpText = true)}
                    on:blur={() => (showHelpText = false)}
                />
            {:else}
                <input
                    type="text"
                    data-test-fanx="form-field-input-text-{(label && label.replace(' ', '-')) || ''}"
                    autocomplete={type}
                    class="form-control"
                    {id}
                    {placeholder}
                    {disabled}
                    {maxLength}
                    bind:value
                    on:input={update}
                    on:focus={() => (showHelpText = true)}
                    on:blur={() => (showHelpText = false)}
                />
            {/if}
            {#if recommendedMaxLength || maxLength}
                <p class={computedClass}>{computedMessage}</p>
            {/if}

            {#if $$slots.right}
                <span class="input-group-addon">
                    <slot name="right" />
                </span>
            {/if}
        </div>
    </div>
</div>
